const requestStatus = [
	{ name: "Action required", value: "ACTION_REQUIRED" },
	{ name: "In Progress", value: "IN_PROGRESS" },
	{ name: "Delayed", value: "DELAYED" },
];

export default requestStatus;
